module.exports = __webpack_public_path__ + "media/coffee-preferences/unsure-6200b744.png";